import React from "react";
import styled from "styled-components";
import { withI18n } from "react-i18next";
// @ts-ignore
import { CWBModal } from "cwb-react";
import { Button, ButtonGroup } from "../Common";
import { ISessionMaterial } from "../../interfaces/ISessionMaterial";
import PlusBlue from "../../images/plus-blue.svg";
import Remove from "../../images/remove.svg";
import EditPen from "../../images/pen.svg";
import CheckGreen from "../../images/check-green.svg";
// @ts-ignore
import { CWBCheckbox, CWBLoadingCrest } from "cwb-react";
import imageSrc from "./../../images/icon-cwb-logo-grey.svg";
import { ISentSessionMaterial } from "../../interfaces/ISentSessionMaterial";
import { isEmail } from "../../helpers";

const SendSessionMaterialModal = (props: {
  className?: any;
  message?: any;
  onConfirm: (e: any) => void;
  onCancel: () => void;
  buttons?: any;
  handleChange: (e: any, s: ISessionMaterial) => void;
  show: boolean;
  t: any;
  sessionMaterials: ISessionMaterial[];
  sentSessionMaterials: ISentSessionMaterial[];
  isReadOnly: boolean;
  onBlurSave: (e: any, o: ISessionMaterial) => void;
  isLoading: boolean;
  addRow: () => void;
  onDelete: (o: ISessionMaterial) => void;
  onClickEdit: (o: ISessionMaterial) => void;
}) => {
  const {
    className,
    message,
    onConfirm,
    onCancel,
    handleChange,
    show,
    t,
    sessionMaterials,
    sentSessionMaterials,
    onBlurSave,
    isLoading,
    addRow,
    onDelete,
    onClickEdit,
  } = props;

  const onChange = (e: any, sessionMaterial: any) => {
    handleChange(e, sessionMaterial);
  };

  const validate = () => {
    const emails = sessionMaterials
      .filter((mat) => mat.email.length)
      .map((mat) => isEmail(mat.email));

    if (emails.length > 0) {
      const isEmailsValid = emails.reduce((acc: boolean, cur: boolean) => {
        return acc && cur;
      }, true);
      return isEmailsValid;
    }

    return true;
  };

  const isEmpty = sessionMaterials.filter((x) => {
    return x.email && x.email.length > 0;
  }).length === 0;

  const disableCreateEpitch = !validate() || isEmpty;

  return (
    <StyledModal
      className={`${className} cwb-modal`}
      title={t(`Send Session Materials`)}
      body={message}
      hideModal={onCancel}
      isOpen={show}
      backdrop="static"
    >
      <div>
        <section>
          <StyledText>
            {/* TODO: t */}
            Enter details to send session materials. All materials will be sent
            as they appear on the page. If new materials are added after this is
            sent you will need to resend.
          </StyledText>
          <form>
            {!isLoading &&
              sessionMaterials &&
              sessionMaterials.map((sessionMaterial, i) => {
                const sent = sentSessionMaterials.find(
                  (x) => x.sentTo === sessionMaterial.email
                )
                  ? true
                  : false;
                const hasRequiredValues = sessionMaterial.email.length > 0;
                const inputClass =
                  sent && hasRequiredValues && !sessionMaterial.isEditable
                    ? "input-readonly"
                    : "form-control";
                return (
                  <div className="form-group row" key={i}>
                    <div className="col-4">
                      {sent &&
                        hasRequiredValues &&
                        !sessionMaterial.isEditable && (
                          <>
                            <StyledSentCheck src={CheckGreen} />
                          </>
                        )}
                      <input
                        type="text"
                        className={`${inputClass} form-input-font`}
                        value={sessionMaterial && sessionMaterial.firstName}
                        onChange={(e) => onChange(e, sessionMaterial)}
                        readOnly={
                          sent &&
                          hasRequiredValues &&
                          !sessionMaterial.isEditable
                        }
                        name="firstName"
                        onBlur={(e) => onBlurSave(e, sessionMaterial)}
                      />
                      <small
                        className="form-text text-muted"
                        style={{ visibility: "hidden" }}
                      >
                        Error
                      </small>
                    </div>
                    <div className="col-custom-4">
                      <input
                        type="text"
                        className={`${inputClass} form-input-font`}
                        value={sessionMaterial && sessionMaterial.lastName}
                        readOnly={
                          sent &&
                          hasRequiredValues &&
                          !sessionMaterial.isEditable
                        }
                        onChange={(e) => onChange(e, sessionMaterial)}
                        name="lastName"
                        onBlur={(e) => onBlurSave(e, sessionMaterial)}
                      />
                      <small
                        className="form-text text-muted"
                        style={{ visibility: "hidden" }}
                      >
                        Error
                      </small>
                    </div>
                    <div className="col-custom-4">
                      <input
                        style={
                          (sessionMaterial.email.length > 0 && !isEmail(sessionMaterial.email))
                            ? { border: '1px solid #E5084A' }
                            : {}
                        }
                        type="text"
                        className={`${inputClass} form-input-font`}
                        value={sessionMaterial && sessionMaterial.email}
                        readOnly={
                          sent &&
                          hasRequiredValues &&
                          !sessionMaterial.isEditable
                        }
                        onChange={(e) => onChange(e, sessionMaterial)}
                        name="email"
                        placeholder="example@example.com*"
                        onBlur={(e) => onBlurSave(e, sessionMaterial)}
                      />
                      <small
                        className="form-text text-muted"
                        style={{ visibility: "hidden" }}
                      >
                        Error
                      </small>

                      {sent &&
                        hasRequiredValues &&
                        !sessionMaterial.isEditable && (
                          <>
                            <StyledEditPenIcon
                              src={EditPen}
                              onClick={() => onClickEdit(sessionMaterial)}
                            />
                            <StyledRemoveIcon
                              src={Remove}
                              onClick={() => onDelete(sessionMaterial)}
                            />
                          </>
                        )}
                    </div>
                  </div>
                );
              })}
            {isLoading && (
              <div style={{ marginBottom: "10px" }}>
                <CWBLoadingCrest customLogoSrc={imageSrc} />
              </div>
            )}
            {!isLoading && (
              <div>
                <StyledImgIcon src={PlusBlue} onClick={addRow} />
                <SpanAddLine onClick={addRow}>
                  {t("Add more recipients")}
                </SpanAddLine>
              </div>
            )}

            <StyledTitle>
              {/* TODO  t => key */}
              Send the following materials to the list above
            </StyledTitle>
            {/* <div className="form-group row">
              <div className="col-12"> */}
            <StyledCheckboxLeft
              style={{ marginLeft: "0px !important" }}
              key={`vslink`}
              isChecked={true}
              name="vslink"
              disabled={true}
              onClick={() => {}}
            />
            <label className="col-form-label">
              {t("Virtual Session Link")}
            </label>
            <StyledCheckboxRight
              style={{ marginLeft: "10px" }}
              key={`epitchmat`}
              isChecked={true}
              name="epitchmat"
              disabled={true}
              onClick={() => {}}
            />
            <label className="col-form-label">{t("Epitch Materials")}</label>
            {/* </div>
            </div> */}
            <div className="form-group" style={{ marginTop: "20px" }}>
              <ButtonGroup>
                <Button
                  disabled={disableCreateEpitch}
                  type="button"
                  onClick={onConfirm}
                >
                  {t("Create Epitch")}
                </Button>
                <Button
                  type="button"
                  variant="secondary"
                  onClick={onCancel}
                >
                  {t("Cancel")}
                </Button>
              </ButtonGroup>
            </div>
          </form>
        </section>
      </div>
    </StyledModal>
  );
};

export default withI18n()(SendSessionMaterialModal);

const StyledModal = styled(CWBModal)`
  width: 100%;
  max-width: 850px !important;
  margin: 0 auto;

  &.create-role-modal {
    max-width: 450px;

    .modal-buttons {
      justify-content: space-around !important;
    }
  }

  .modal-header: {
    justify-content: left !important;
  }

  .modal-dropdown {
    min-width: 200px;
    max-width: 200px;
    .cwb-dropdown__menu {
      .cwb-dropdown__option {
        min-width: 185px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
  }

  .modal-content {
    width: 100%;
  }

  .modal-body {
    margin-bottom: 10px;
    padding-bottom: 6px;
    text-align: left !important;
  }

  .modal-buttons {
    justify-content: space-between !important;
  }

  .close-modal {
    right: 20px;

    &:before {
      color: #8395a7;
      font-size: 16px;
    }
  }

  .cwb-dropdown-wrapper {
    .cwb-dropdown__menu-list {
      text-align: left;
    }
  }
`;

const StyledTitle = styled.div`
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 22px;

  color: #364866;
  margin-top: 10px;
  margin-bottom: 10px;
`;

const StyledText = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: #364866;
  margin-bottom: 30px;
`;

const SpanAddLine = styled.span`
  margin-left: 5px;
  color: #00aaff;
  cursor: pointer;
`;

const StyledImgIcon = styled.img`
  padding-bottom: 2px;
  cursor: pointer;
`;

const StyledRemoveIcon = styled.img`
  padding-bottom: 2px;
  cursor: pointer;
  position: absolute;
  right: -8px;
  top: 10px;
`;

const StyledEditPenIcon = styled.img`
  padding-bottom: 2px;
  cursor: pointer;
  position: absolute;
  right: 13px;
  top: 11px;
`;

const StyledSentCheck = styled.img`
  cursor: pointer;
  position: absolute;
  top: 9px;
  left: -3px;
`;

const StyledCheckboxLeft = styled(CWBCheckbox)`
  display: inline;
  margin-left: 0px;
  margin-right: 7px;
  .icon-cwb-unchecked:before {
    font-size: ${(p) => p.theme["font-size"]};
  }
  .icon-cwb-checked:before {
    font-size: ${(p) => p.theme["font-size"]};
    color: #a0a1a5; /*${(p) => p.theme.darkBlue};*/
  }
  &.child-cb {
    margin-left: 40px;
  }

  &.small-cb {
    display: flex;
    align-items: center;
    .icon-cwb-unchecked,
    .icon-cwb-unchecked:before,
    .icon-cwb-checked,
    .icon-cwb-checked:before {
      font-size: ${(p) => p.theme["sm-cb-font"]};
    }
  }
`;
const StyledCheckboxRight = styled(CWBCheckbox)`
  display: inline;
  margin-left: 17px;
  margin-right: 7px;
  .icon-cwb-unchecked:before {
    font-size: ${(p) => p.theme["font-size"]};
  }
  .icon-cwb-checked:before {
    font-size: ${(p) => p.theme["font-size"]};
    color: #a0a1a5; /*${(p) => p.theme.darkBlue};*/
  }
  &.child-cb {
    margin-left: 40px;
  }

  &.small-cb {
    display: flex;
    align-items: center;
    .icon-cwb-unchecked,
    .icon-cwb-unchecked:before,
    .icon-cwb-checked,
    .icon-cwb-checked:before {
      font-size: ${(p) => p.theme["sm-cb-font"]};
    }
  }
`;
